import React, { useState } from "react";
import { useAuth } from "../../context/context";
import { useFavorites } from "../../context/context";
import { useApp } from "../../hooks/useApp";
import { IconButton, Snackbar, Alert, Button, Tooltip } from "@mui/material";
import { Favorite, FavoriteBorder } from "@mui/icons-material";

export const FavoriteButton = ({
  product,
  sx = {},
  mode = "icon",
  externalSetSnackbarMessage,
  externalSetSnackbarOpen,
  externakSetSnackbarSeverity,
}) => {
  const { user } = useAuth();
  const { openLoginModal } = useApp();
  const { isFavorite, toggleFavorite, loading } = useFavorites(); // 🔧 Usar contexto que usa useFreshFavorites
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const isProductFavorite = isFavorite(product?.id);

  const handleFavoriteClick = async (e) => {
    e.stopPropagation(); // Evitar navegar al hacer click en favoritos

    if (!user && typeof openLoginModal === "function") {
      openLoginModal();
      return;
    }

    if (!product?.id) {
      console.warn("⚠️ Product ID is required for favorites");
      return;
    }

    try {
      const wasAdded = await toggleFavorite(product);

      if (wasAdded) {
        let message = "Producto agregado a favoritos";
        externalSetSnackbarMessage
          ? externalSetSnackbarMessage(message)
          : setSnackbarMessage(message);
        setSnackbarSeverity("success");
      } else {
        let message = "Producto removido de favoritos";
        externalSetSnackbarMessage
          ? externalSetSnackbarMessage(message)
          : setSnackbarMessage("Producto removido de favoritos");
        setSnackbarSeverity("info");
      }
      externalSetSnackbarOpen
        ? externalSetSnackbarOpen(true)
        : setSnackbarOpen(true);
    } catch (error) {
      let message = "Error al actualizar favorito";
      externalSetSnackbarMessage
        ? externalSetSnackbarMessage(message)
        : setSnackbarMessage("Error al actualizar favorito");
      externakSetSnackbarSeverity
        ? externakSetSnackbarSeverity("error")
        : setSnackbarSeverity("error");
      externalSetSnackbarOpen
        ? externalSetSnackbarOpen(true)
        : setSnackbarOpen(true);
      console.error("Error toggling favorite:", error);
    }
  };

  if (!product) return null;

  if (mode === "button") {
    return (
      <>
        <Tooltip
          title={user ? "Añadir a favoritos" : "Inicia sesión para guardar"}
        >
          <Button
            variant={isProductFavorite ? "contained" : "outlined"}
            startIcon={isProductFavorite ? <Favorite /> : <FavoriteBorder />}
            size="small"
            onClick={handleFavoriteClick}
            disabled={loading}
            sx={{
              color: isProductFavorite ? "white" : "inherit",
              backgroundColor: isProductFavorite ? "#ff4569" : "transparent",
              borderColor: "#ff4569",
              "&:hover": {
                backgroundColor: isProductFavorite
                  ? "#e53e5a"
                  : "rgba(255, 69, 105, 0.1)",
              },
              "&:disabled": {
                opacity: 0.6,
              },
              ...sx,
            }}
          >
            {loading ? "..." : isProductFavorite ? "Guardado" : "Guardar"}
          </Button>

          {/* Snackbar para notificaciones */}
          <Snackbar
            open={snackbarOpen}
            autoHideDuration={3000}
            onClose={() => setSnackbarOpen(false)}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          >
            <Alert
              onClose={() => setSnackbarOpen(false)}
              severity={snackbarSeverity}
              variant="filled"
            >
              {snackbarMessage}
            </Alert>
          </Snackbar>
        </Tooltip>
      </>
    );
  }

  return (
    <>
      <IconButton
        onClick={handleFavoriteClick}
        disabled={loading}
        className="favorite-button"
        sx={{
          ...sx,
          "&:disabled": {
            opacity: 0.6,
          },
        }}
      >
        <Tooltip
          title={user ? "Añadir a favoritos" : "Inicia sesión para guardar"}
        >
          {isProductFavorite ? (
            <Favorite
              sx={{
                color: "#ff4569",
                filter: "drop-shadow(0 1px 2px rgba(0,0,0,0.5))",
                fontSize: "1.2rem",
              }}
            />
          ) : (
            <FavoriteBorder
              sx={{
                color: "white",
                filter: "drop-shadow(0 1px 2px rgba(0,0,0,0.5))",
                fontSize: "1.2rem",
              }}
            />
          )}
        </Tooltip>
      </IconButton>

      {/* Snackbar para notificaciones */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          variant="filled"
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};
